import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-committee24',
  templateUrl: './program-committee.component.html',
  styleUrls: ['./program-committee.component.css']
})
export class ProgramCommitteeComponent24 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
